import PropTypes from 'prop-types';

export default {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  headingRenderer: PropTypes.func,
  ItemComponent: PropTypes.func.isRequired,
  ItemChildren: PropTypes.func,
  itemKey: PropTypes.string.isRequired,
  itemType: PropTypes.string.isRequired,
  itemWidth: PropTypes.number,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  showAll: PropTypes.bool,
  onItemClick: PropTypes.func,
  prefixItems: PropTypes.arrayOf(PropTypes.node),
  hasValidSubscription: PropTypes.bool,
};
